import { StorageDetails } from 'components';

export const DetailsPage = () => <StorageDetails pageName="Storage" />;
